import qwest from 'qwest';
import NoteModel from 'models/note';

export function saveNote(note) {
  return qwest.post('/note', note)
    .then((xhr, res) => res.data);
}

export function getAllNotes(customerID) {
  return qwest.get(`/note/all/${customerID}`)
    .then((xhr, res) => res.data)
    .then(data => (data || []).map(NoteModel.fromApiFormat));
}
